import { render, staticRenderFns } from "./import-division-case.vue?vue&type=template&id=09e0d24a&scoped=true"
import script from "./import-division-case.vue?vue&type=script&lang=ts"
export * from "./import-division-case.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e0d24a",
  null
  
)

export default component.exports